<div class="flex f-fd--column">
  <div>
    <howden-page-title></howden-page-title>
  </div>
  <div class="flex f-basis--12">
    <mat-card appearance="outlined">
      <mat-card-header class="flex f-jc--center">
        <mat-card-title i18n="@@app.home.personal-insurance.label">Seguros Personales</mat-card-title>
      </mat-card-header>
      <mat-divider></mat-divider>
      <mat-card-actions class="flex f-jc--center">
        <button mat-raised-button class="flex f-jc--center f-basis--6 f-ai--center" (click)="onSane()">
          <div class="flex f-jc--center f-basis--12">
            <mat-icon>diversity_2</mat-icon>
          </div>
          <span class="flex f-jc--center f-basis--12" i18n="@@app.home.personal-insurance.sane.label">Ramos SANE</span>
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
  <div class="flex f-basis--12">
    <mat-card appearance="outlined">
      <mat-card-header class="flex f-jc--center">
        <mat-card-title i18n="@@app.home.patrimonial-insurance.label">Seguros Patrimoniales</mat-card-title>
      </mat-card-header>
      <mat-divider></mat-divider>
      <mat-card-actions class="flex f-jc--center">
        <button mat-raised-button class="flex f-jc--center f-basis--6 f-ai--center" (click)="onFileLibrary()">
          <div class="flex f-jc--center f-basis--12">
            <mat-icon>list_alt</mat-icon>
          </div>
          <span class="flex f-jc--center f-basis--12"
            i18n="@@app.home.patrimonial-insurance.civil-liability.label">Responsabilidad Civil</span>
          <span class="flex f-jc--center f-basis--12" style="font-size: 0.8em"
            i18n="@@app.home.patrimonial-insurance.civil-liability.label">Consulta en Biblioteca</span>
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
